import { IRfeDialogResult, IRfePanelResult } from '../../typings/window';

interface IPanelCloseHandler {
	(result: IRfePanelResult): void;
}

interface IDialogCloseHandler {
	(result: IRfeDialogResult): void;
}

let mlPanelCloseCallback: IPanelCloseHandler;
let mlDialogCloseCallback: IDialogCloseHandler;

window.OnDialogClose = (result: IRfeDialogResult) => {
	if (result.op === 'dlgcancel') {
		mlPanelCloseCallback = undefined;
	}

	if (mlDialogCloseCallback) {
		mlDialogCloseCallback(result);
	}
};

window.OnDialogCancel = () => {
	mlDialogCloseCallback = undefined;
};

window.onPanelClose = (result: IRfePanelResult) => {
	if (result['isCancel'] === true) {
		mlPanelCloseCallback = undefined;
	}

	if (mlPanelCloseCallback) {
		mlPanelCloseCallback(result);
	}
};

export default class RfeMlPanel {
	public static load(url: string, callback?: IPanelCloseHandler): void {
		RfeMlPanel.throwErrorIfCallbackExists();

		mlPanelCloseCallback = result => {
			mlPanelCloseCallback = undefined;
			callback?.call(this, result);
		};

		window.MLPanel.load(url);
	}

	public static navigate(url: string): void {
		window.MLPanel.navigate(url, false);
	}

	public static loadDialog(url: string, callback?: IDialogCloseHandler, options?: unknown): void {
		RfeMlPanel.throwErrorIfDialogCallbackExists();

		mlDialogCloseCallback = result => {
			mlDialogCloseCallback = undefined;
			callback?.call(this, result);
		};

		window.MLPanel.load(url, true, options);
	}

	public static showAsync(url: string): Promise<IRfePanelResult> {
		return new Promise<IRfePanelResult>(r => {
			RfeMlPanel.throwErrorIfCallbackExists();

			mlPanelCloseCallback = result => {
				mlPanelCloseCallback = undefined;
				r(result);
			};

			window.WebDialog.show(url);
		});
	}

	private static throwErrorIfCallbackExists() {
		if (mlPanelCloseCallback) {
			throw new Error('Callback function already exists.');
		}
	}

	private static throwErrorIfDialogCallbackExists() {
		if (mlDialogCloseCallback) {
			throw new Error('Dialog callback function already exists.');
		}
	}
}
